<template>
  <layout name="LayoutDefault">
    <div class="About">
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="section-items">
                <div class="row">
                  <div class="col-lg-4">
                    <img
                      v-if="cms.image"
                      v-bind:src="`${IMAGEURL}${cms.image}`"
                      alt="about"
                      class="img-responsive mb-3"
                    />
                  </div>
                  <div class="col-lg-8">
                      <div
                        class="mb-3 horizontal-share-buttons d-flex justify-content-start align-items-center"
                      >
                        <div>Share on</div>
                        <ShareNetwork
                          v-for="network in networks"
                          :network="network.network"
                          :key="network.network"
                          :style="{ backgroundColor: network.color }"
                          :url="sharing.url"
                          :title="sharing.title"
                          :description="sharing.description"
                          :quote="sharing.quote"
                          :hashtags="sharing.hashtags"
                          :twitterUser="sharing.twitterUser"
                          class="mx-1 text-white"
                        >
                          <i :title="network.name" :class="network.icon" class="p-2"></i>
                        </ShareNetwork>
                      </div>

                    <div>
                      <h2>{{ cms.title }}</h2>
                    </div>
                    <div v-html="`${cms.description}`"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Home`,
  data() {
    return {
      cms: {
        image: null
      },
      currentUrl: window.location.href,
      sharing: {
        url: this.baseUrl + "/blogs/" + this.$route.params.id,
        //url: "https://kathaprokash.com/blogs/108",
        title: "",
        description: "",
        quote: "",
        hashtags: "কথাপ্রকাশ",
        twitterUser: ""
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: "fa fa-facebook",
          color: "#1877f2"
        },
        {
          network: "linkedin",
          name: "LinkedIn",
          icon: "fa fa-linkedin",
          color: "#007bb5"
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fa fa-twitter",
          color: "#1da1f2"
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa fa-whatsapp",
          color: "#25d366"
        }
      ],
    };
  },
  components: {
    Layout,
  },
  methods: {
    async getCms() {
      const response = await this.$http.get(`cms/${this.$route.params.id}`);
      if (response.data.status) {
        this.cms = response.data.data;
        this.setTitle(this.cms.title);

        this.sharing.title = this.cms.title;
        //console.log('this.sharing.title', this.sharing.title)
        this.sharing.description = this.cms.short_description;

        document.querySelector('meta[property="og:title"]').setAttribute("content", this.cms.title);
        document.querySelector('meta[property="og:description"]').setAttribute("content", this.cms.short_description);
        document.querySelector('meta[property="og:image"]').setAttribute("content", `${this.IMAGEURL}${this.cms.image}`);
        document.querySelector('meta[property="twitter:card"]').setAttribute("content", `${this.IMAGEURL}${this.cms.image}`);
        document.querySelector('meta[property="og:url"]').setAttribute("content", this.baseUrl + "/blogs/" + this.$route.params.id);
      }
    },
  },
  mounted() {
    this.getCms();
  },
};
</script>
